<template>
  <router-link v-bind="$attrs" :to="{name: 'Main', params : { 'locale' : locale === 'en' ? 'en' : undefined }}" class="header-logo">
    <!-- NOTE: v-if 사용시 사파리 렌더링 버그로 간격이 생겨 none, block으로 처리  -->
    <logo-en v-show="locale === 'en'" />
    <logo v-show="locale !== 'en'" />
    <span hidden>{{ $t('woowabrothers') }}</span>
  </router-link>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {
    logo: () => import('@/static/svg/logo.svg'),
    logoEn: () => import('@/static/svg/logo-en.svg'),
  },
  computed: {
    ...mapGetters({
      locale: 'locale/GET_LOCALE',
    }),
  }
}
</script>
